import { render, staticRenderFns } from "./pointsRecord.vue?vue&type=template&id=9c9b90b0&scoped=true"
import script from "./pointsRecord.vue?vue&type=script&lang=js"
export * from "./pointsRecord.vue?vue&type=script&lang=js"
import style0 from "./pointsRecord.vue?vue&type=style&index=0&id=9c9b90b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9b90b0",
  null
  
)

export default component.exports